import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { useTenants } from '@/services/tenants/useTenants';
import { queryFunction, queryKey } from './query';

export const useFetchVisualSearch = ({
  files,
  searchQuery,
  metadataFilters,
  folders,
  extensions,
  onError,
  tenantId,
}: {
  files?: File[];
  searchQuery?: string;
  metadataFilters?: string;
  folders?: string;
  extensions?: string;
  onError?: (error: Error) => void;
  tenantId?: string;
}) => {
  const { getTenantId } = useTenants();
  const searchTenantId = tenantId ?? getTenantId();

  const hasFiles = files && files.length > 0;

  return useDataGridFetcher({
    queryKey: parameters =>
      queryKey({
        files: hasFiles ? files : [],
        searchQuery: searchQuery ?? '',
        metadataFilters,
        folders,
        extensions,
        tenantId: searchTenantId,
        ...parameters,
      }),
    queryFn: parameters =>
      queryFunction({
        files: hasFiles ? files : [],
        searchQuery: searchQuery ?? '',
        metadataFilters,
        folders,
        extensions,
        tenantId: searchTenantId,
        ...parameters,
      }),
    onError,
  });
};
